module.exports = __webpack_public_path__ + "static/media/28.7aeed7f8.jpg";